module.exports = __webpack_public_path__ + "img/22.f9302762.jpg";